import { Box, Grid } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { VideosFilterDateAdded } from 'components/sections/video-library/table/toolbar/filter-date-added';
import { VideosFilterDelivery } from 'components/sections/video-library/table/toolbar/filter-delivery';
import { VideosFilterPitchType } from 'components/sections/video-library/table/toolbar/filter-pitch-type';
import { VideosFilterPitcher } from 'components/sections/video-library/table/toolbar/filter-pitcher';
import { VideosFilterTeamName } from 'components/sections/video-library/table/toolbar/filter-team-name';
import { CheckedContext } from 'contexts/layout/checked.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';

export const VideoLibraryTableToolbar = () => {
  const { resetChecked } = useContext(CheckedContext);

  return (
    <ErrorBoundary identifier="VideoLibraryTableToolbar">
      <Grid columns="5" gap={RADIX.FLEX.GAP.SM}>
        <Box>
          <VideosFilterTeamName onChange={resetChecked} />
        </Box>
        <Box>
          <VideosFilterPitcher onChange={resetChecked} />
        </Box>
        <Box>
          <VideosFilterPitchType onChange={resetChecked} />
        </Box>
        <Box>
          <VideosFilterDelivery onChange={resetChecked} />
        </Box>
        <Box>
          <VideosFilterDateAdded onChange={resetChecked} />
        </Box>
      </Grid>
    </ErrorBoundary>
  );
};
